import Routing from './routes'
import { BrowserRouter as Router } from "react-router-dom";
import { Box } from '@mui/system';

function App() {
  return (
      <Box 
        sx={{
          backgroundColor:"#1e4d7d",
          minHeight:"100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
          <Router>
            <Routing/>
          </Router>
      </Box>
  );
}

export default App;
